module.exports = __webpack_public_path__ + "img/more.bbbc6a9c.png";